exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".form-content-half .el-form-item__content{max-width:50%}.form-panel{margin:20px 0 0;width:100%;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}", "", {"version":3,"sources":["/workspace/src/views/task/pages/ReviewPlanFormPage.vue"],"names":[],"mappings":"AACA,0CAA0C,aAAa,CACtD,AACD,YAAY,gBAAgB,WAAW,qBAAqB,kBAAkB,wBAAwB,CACrG","file":"ReviewPlanFormPage.vue","sourcesContent":["\n.form-content-half .el-form-item__content{max-width:50%\n}\n.form-panel{margin:20px 0 0;width:100%;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7bae70be","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/task/pages/ReviewPlanFormPage.vue
// module id = 5558
// module chunks = 103